import en from "./en";
import fr from "./fr";
import de from "./de";
import es from "./es";

const CONTENT = Object.freeze({ en, fr, de, es });

export function getMarketingContent(locale) {
  const language = String(locale || "en").toLowerCase().split("-")[0];
  return CONTENT[language] || CONTENT.en;
}

export const MARKETING_LOCALES = Object.freeze(Object.keys(CONTENT));

export default CONTENT;
